/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2018-12-28 12:09:05
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-06-08 09:31:29
 */
export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : (hour <= 11 ? '上午好' : (hour <= 13 ? '中午好' : (hour < 20 ? '下午好' : '晚上好')))
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor((Math.random()*arr.length))
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.getElementById(id).remove()
  }, timeout)
}

export const detailFormat = (text='') =>{
  const textArr = text.split('\\n')
  return (h)=>{
      return (<div>
        {textArr.map(item => (<p style="margin-bottom:0">{item}</p>))}
      </div>)
    }
}

export const errorMsg = (err, fieldLabels) => {
  const errRes = err.response
  console.log(errRes.data.detail, 'errRes')
  if (String(errRes && errRes.status).indexOf('50') == 0) {
    return errRes.statusText ? "服务器异常：" + errRes.statusText : "服务器异常"
  } else if (errRes && errRes.status == '499') {
    return detailFormat(errRes.data.detail)
  } else if (errRes && (errRes.status == '406' || errRes.status == '404' || errRes.status == '429')) {
    return errRes.data.detail
  }else if (errRes && errRes.status == '400') {
    const errObj = errRes.data
    let errMsg = ""
    for (let key in errObj) {
      errMsg +=
        (key||'错误') + "：" + errObj[key][0] + ' \n ';
    }
    return errMsg || "请求出现错误，请稍后再试";
  }else{
    return '意外错误'
  }
  return (
    ((errRes || {}).data || {}).error ||
    ((errRes || {}).data || {}).message ||
    "请求出现错误，请稍后再试"
  );
}

//设置cookie  
export function setCookie(name, value, seconds) {
  seconds = seconds || 0;   //seconds有值就直接赋值，没有为0    
  var expires = "";
  if (seconds != 0) {      //设置cookie生存时间    
    var date = new Date();
    date.setTime(date.getTime() + (seconds * 1000));
    expires = "; expires=" + date.toGMTString();
  }
  document.cookie = name + "=" + escape(value) + expires + "; path=/";   //转码并赋值    
}

//取得cookie    
export function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';'); //把cookie分割成组    
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]; //取得字符串    
    while (c.charAt(0) == ' ') { //判断一下字符串有没有前导空格    
      c = c.substring(1, c.length); //有的话，从第二位开始取    
    }
    if (c.indexOf(nameEQ) == 0) { //如果含有我们要的name    
      return unescape(c.substring(nameEQ.length, c.length)); //解码并截取我们要值    
    }
  }
  return false;
}

//base64转文件流
export function  dataURLtoFile(dataurl, filename) { 
  var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
  while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

/**
 * @description: 格式化座席信息
 * @param {Object} seat
 * @return 姓名(电话后四位)
 */
export const formatSeat = (seat) => {
  return `${seat.nickname}(${seat.username.substring(seat.username.length - 4)})`
}


// WEBPACK FOOTER //
// ./src/utils/util.js